import { NavLink } from 'react-router-dom';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useTranslation } from 'react-i18next';

const linkSx = (isActive: boolean | undefined) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  px: 1,
  py: 0.5,
  borderRadius: 1,
  color: isActive ? '#21a598' : undefined,
});

export default function ReunionesReportsLayout() {
  const { t } = useTranslation<'translation'>();
  return (
    <Box sx={{ display: 'flex', minHeight: '100%' }}>
      <Box sx={{ width: 220, borderRight: 1, borderColor: 'divider', px: 2, py: 3 }}>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t('reunionesReportsLayout.titulo', 'Reuniones')}
        </Typography>
        <List dense disablePadding>
          <NavLink to="metricas">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <TimelineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reunionesReportsLayout.menu.metricas', 'Métricas')} />
              </ListItemButton>
            )}
          </NavLink>
        </List>
      </Box>
      <Box sx={{ flex: 1, p: 2 }}>
        {/* outlet */}
      </Box>
    </Box>
  );
}

